<div class="d-flex align-items-center w-100">
  <app-ag-addresses [addresses]="addresses()"/>

  @if (!matches()) {
    <div class="mismatch-icon-wrapper">
      <app-ag-action-icon-button
        iconClass="ic-form-20"
        (action)="onUpdateMisMatch()"
      />
    </div>
  }
</div>
